import * as request from 'requestES';
import { getParam } from "utilsES";
import $ from "jquery";


const matchHost = window.location.host.match(/\.?([A-za-z0-9]*\.com)/);
export const HOST = matchHost ? matchHost[1] : '37games.com';
const gameMark = {
	191: "gamecode",
	217: "yysjgiftcode",
	263: "antgiftcode",
	288: 'antgiftcode',
	285: 'dtmslggiftcode',
	354: 'dtmslggiftcode',
	355: 'dtmslggiftcode',
	295: 'beastgiftcode',
	331: 'zljslggiftcode',
	440: 'xdgslggiftcode',
	466: 'xdgslggiftcode',
	454: 'zroutegiftcode',
}

export const gameId = (() => {
	let gameId = getParam('gameId');
	if(gameId == 288) return 263;
	if(gameId == 354 || gameId == 355) return 285;
	if(gameId == 466) return 440;
	if (!Object.keys(gameMark).includes(gameId)) {
		gameId = 191;
	}
	return gameId;
})();

const activityName = gameMark[gameId];
const URL = `//geventsapi.${HOST}/activity/execute?name=${activityName}&action=`;
const AWARD_URL = `//geventsapi.${HOST}/activity/execute?name=gamecode&action=`;

// get请求，参数在params内
export const get = function (action, params, isAwardUrl = false) {
	return request.ajax({
		url: `${isAwardUrl ? AWARD_URL : URL}${action}`,
		data: Object.assign(params || {}, {
			scid: getParam('scid'),
			cid: getParam('cid')
		})
	})
}

// 参数在params外
export const getParamOuter = function (action, params = {}) {
	return new Promise((resolve, reject) => {
		$.ajax({
			type: "get",
			url: URL + action,
			data: {
				...params
			},
			dataType: "jsonp",
			jsonp: "callback",
			beforeSend: function (jqXHR, settings) {
				//在请求前给修改url（增加一个时间戳参数）
				settings.url += settings.url.match(/\?/) ? "&" : "?";
				settings.url += `cid=${getParam("cid") || 0}&scid=${getParam("scid")}`;
			},
			success: function (res) {
				if (parseInt(res.result) === 1) {
					resolve(res);
				} else {
					reject(res);
				}
			},
			error: function (errMsg) {
				reject(errMsg);
			}
		});
	});
}

// 获取登录账户信息
export const getUserInfo = function () {
	return request.ajax({
		url: `//gpassport.${HOST}/center/ajax/get_user_json`
	})
}

// 登出
export const getLogout = function () {
	return request.ajax({
		url: `//gpassport.${HOST}/web_login/logout`
	})
}

// 查询角色
export const getRole = function (params) {
	return get('getMobileGameRole', params);
}


